import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home')
    },
    {
      path: '/tech',
      name: 'tech',
      component: () => import('../views/tech')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('../views/product')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../views/news')
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import('../views/newsDetail')
    },
    {
      path: '/hmo',
      name: 'hmo',
      component: () => import('../views/hmo')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/about')
    },
    {
      path: '/join',
      name: 'join',
      component: () => import('../views/join')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/contact')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js